var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FormControl } from "@angular/forms";
import { BaseModalComponent } from "app/views/modal/base_modal.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { HelperService } from "app/lib/helper.service";
import { SupportService } from "app/support/support/support.service";
import { FormControlValidators } from "../../../models/validators/validator";
import { SupportModalForm } from "../../../models/form";
import * as moment from 'moment-timezone';
var getAmountValidatorList = function (amount) {
    return [
        FormControlValidators.lte(amount),
    ];
};
var ɵ0 = getAmountValidatorList;
var getDateToValidatorList = function () {
    return [
        FormControlValidators.date(),
    ];
};
var ɵ1 = getDateToValidatorList;
var ReturnPaidComponent = /** @class */ (function (_super) {
    __extends(ReturnPaidComponent, _super);
    function ReturnPaidComponent(activeModal, helper, supportService) {
        var _this = _super.call(this, activeModal) || this;
        _this.activeModal = activeModal;
        _this.helper = helper;
        _this.supportService = supportService;
        _this.providerNameList = [];
        _this.roleNameList = [];
        _this.isBtnOkActive = false;
        _this.types = [
            'warrantyPeriod',
            'partialRefund',
            'secondPaid',
            'other',
        ];
        _this.stayTariffs = [
            'manual',
            'stay10days',
        ];
        _this.form = new SupportModalForm({
            transactionId: new FormControl('', [
                FormControlValidators.required(),
                FormControlValidators.minLength(4),
            ]),
            type: new FormControl(),
            amount: new FormControl(),
            stayTariff: new FormControl(),
            dateTo: new FormControl(),
        });
        return _this;
    }
    Object.defineProperty(ReturnPaidComponent.prototype, "transactionId", {
        get: function () {
            return this.form.get('transactionId');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReturnPaidComponent.prototype, "type", {
        get: function () {
            return this.form.get('type');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReturnPaidComponent.prototype, "amount", {
        get: function () {
            return this.form.get('amount');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReturnPaidComponent.prototype, "stayTariff", {
        get: function () {
            return this.form.get('stayTariff');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReturnPaidComponent.prototype, "comment", {
        get: function () {
            return this.form.get('comment');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReturnPaidComponent.prototype, "dateTo", {
        get: function () {
            return this.form.get('dateTo');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReturnPaidComponent.prototype, "transaction", {
        get: function () {
            var transactionId = parseInt(this.transactionId.value, 10);
            return this.transactions.find(function (i) { return i.transactionId == transactionId; });
        },
        set: function (transaction) {
            this.transactionId.setValue(transaction.transactionId);
            this.amount.setValue(transaction.amount);
        },
        enumerable: true,
        configurable: true
    });
    ReturnPaidComponent.prototype.ngOnInit = function () {
        var me = this;
        me.transactionId.valueChanges.subscribe(function () {
            var transaction = me.transaction;
            me.amount.setValue(transaction.amount);
        });
        me.type.valueChanges.subscribe(function (type) {
            if (type === 'partialRefund' || type === 'other') {
                // Валидаторы нужно сбрасывать всегда, иначе в нем замыкается значение amount из invoice.
                // При выборе инвойса с другой суммой, значение в валидаторе lte останется старым
                me.amount.setValidators(getAmountValidatorList(me.transaction.amount));
                me.amount.updateValueAndValidity();
                return;
            }
            me.amount.setErrors(null);
            me.amount.setValidators(null);
        });
        me.type.setValue(this.types[0]);
        me.stayTariff.valueChanges.subscribe(function (stayTariff) {
            if (stayTariff === 'manual') {
                me.dateTo.setValidators(getDateToValidatorList());
                me.dateTo.updateValueAndValidity();
                return;
            }
            me.dateTo.setErrors(null);
            me.dateTo.setValidators(null);
        });
        me.stayTariff.setValue(this.stayTariffs[0]);
    };
    ReturnPaidComponent.prototype.niceTransaction = function (transaction) {
        return transaction.transactionId + " - $" + transaction.amount + ", " + moment(transaction.transactionDate).format('YYYY-MM-DD HH:mm') + ", " + transaction.tariffId + "/" + transaction.tariffVariant;
    };
    return ReturnPaidComponent;
}(BaseModalComponent));
export { ReturnPaidComponent };
export { ɵ0, ɵ1 };
